import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=11a11285&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"
import style0 from "./admin.vue?vue&type=style&index=0&id=11a11285&prod&scoped=true&lang=css"
import style1 from "./admin.vue?vue&type=style&index=1&id=11a11285&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a11285",
  null
  
)

export default component.exports